import React,{useState,useEffect} from 'react'
import {Box,Button, Heading,Text,Layer,DataTable,Tag} from 'grommet'
import { withRouter } from 'react-router-dom';
import { API,Auth } from 'aws-amplify';
import { Add,FormUpload,Package } from 'grommet-icons';

const ReturnCommodities = (commodities,select) => {
  var updatedCommodities = []
      commodities.forEach((c,i) => {
        if (select.includes(c.id)){
          c.select = true
          updatedCommodities.push(c)
        } else {
          c.select = false
          updatedCommodities.push(c)
        }
      })
      return updatedCommodities
}

const returnCommodityActive = (commodity) => {
  if (commodity.select){
    return <Box direction='row' margin='xsmall'><Tag background={{ color: 'status-ok', opacity: "strong" }} size='small' value={"Active"} /></Box>
  } else {
    return <Box direction='row' margin='xsmall'><Tag background={{ color: 'status-disabled', opacity: "strong" }} size='small' value={"Inactive"} /></Box>
  }
}


function AddCommodities(props){
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(undefined);
    const [open, setOpen] = React.useState();
    const [commodities, setCommodities] = useState([]);
    const [select, setSelect] = useState([]);
   
    useEffect(() => { 
      Auth.currentSession().then(session => {
        API.get("LabShip", `/set_lab_commodities?lab=${props.lab.id}`,{headers: {Authorization: session.idToken.jwtToken,}})
        .then(
          (result) => {
            var activeCommodities = []
            result.forEach((res,i) => {
              if (res.select){
                activeCommodities.push(res.id)
              }
            })
            setSelect(activeCommodities)
            setCommodities(result)            
          },
          (error) => {
            console.log(error)
          }
        )
      })   
     },[]);

     const onSubmit = () => {
      var updatedCommodities = ReturnCommodities(commodities,select)
      Auth.currentSession().then(session => {
      API.post("LabShip", `/update_lab_commodities`,{headers: { Authorization: session.idToken.jwtToken,},body: {commodities: updatedCommodities,lab:props.lab}})
      .then(commodity => {setOpen(undefined);props.history.push(`/admin/labs/edit/${props.lab.id}`); props.setCommoditySuccess(true)})
      })
     }
    return (
        <Box margin='small' justify='end' alignSelf='end'>
          <Button size='small' margin='small' icon={<Add color='brand' />} label="Add Commodities" onClick={onOpen}/>
        {open && (
            <Layer position="center" onClickOutside={onClose} onEsc={onClose}>
              <Box pad="medium" style={{minWidth:1400}}>
                <Box direction='row' justify='between'>
                  <Heading level={3} margin="none">
                    Commodities
                  </Heading>
                  <Package color='brand' />
                </Box>
                <Text margin={{top: 'large'}} size='small'>Add and Remove Commodities using the tick boxes</Text>
                <Box style={{overflow: 'scroll'}}>
                  {console.log(select)}
                  <DataTable pin="header" onClickRow={()=>{}} pad='small'columns={[{header:"ID",property:"id",primary:true,sortable:true,search:false},{header:"Name",property:"name", search:true},{header:"Description",property:"description"},{header:"HS Code",property:"code"},{header:"Owner",property:"owner.name"},{header:"Active",sortable:true,property:"select", render: (datum) => returnCommodityActive(datum)}]}select={select}onSelect={setSelect}data={commodities}step={10}/>
                </Box>
                <Box as="footer" gap="small" direction="row" align="center" justify="end" pad={{ top: 'medium', bottom: 'small' }}>
                  <Button primary icon={<FormUpload />} label={<Text size='small' color="white"><strong>Update Commodities</strong></Text>} onClick={onSubmit}  color="brand" />
                </Box>
              </Box>
            </Layer>
          )}
          </Box>
    )
}

export default withRouter(AddCommodities)
